const createNullPoint = (time) => ({ time, value: null });

export const modifyHRData = (filter, data = []) => {
  if (!data.length) {
    return [createNullPoint(filter.dateFrom), createNullPoint(filter.dateTo)];
  }

  return data;
};
